$(document).ready(function() {
$(".accordion").find("summary").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    //$(this).parents("details").find(".accordion__content").slideToggle();
    //$(this).parents("details").attr("open","");
    //$(this).attr("aria-expanded","false");
    $(this).parents("details").toggleClass("faq-open");
  if( $(this).parents("details").hasClass("faq-open") )
  {
    $(this).parents("details").attr("open","");
  }
  else
  {
    $(this).parents("details").removeAttr("open");
  }
  })
  $("button.register-feed a").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    // $('html, body').animate({
    //     scrollTop: $(".register-purchase-form").offset().top
    // }, 400);
    document.getElementById('shopify-section-register-purchase-form').scrollIntoView({
            behavior: 'smooth'
        });
});
});